import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class DataSecurityError extends CodedError {
  static get errorName() {
    return errorCodes.dataSecurityError.code;
  }

  constructor(message: string = errorCodes.dataSecurityError.message) {
    super(message);
    this.code = errorCodes.dataSecurityError.code;
    this.message = `${message} ${errorCodes.dataSecurityError.code}`;
    this.name = errorCodes.dataSecurityError.name;
  }
}
